import { render, staticRenderFns } from "./EquipamientoForm.vue?vue&type=template&id=1b6cc8f2&scoped=true"
import script from "./EquipamientoForm.vue?vue&type=script&lang=js"
export * from "./EquipamientoForm.vue?vue&type=script&lang=js"
import style0 from "./EquipamientoForm.vue?vue&type=style&index=0&id=1b6cc8f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b6cc8f2",
  null
  
)

export default component.exports